export default "__VITE_ASSET__Djj3Tnnb__"